/**
 * PWA / home-screen install helpers (browser-only).
 */

export function isPwaStandalone() {
  if (typeof window === 'undefined') return false;
  try {
    return (
      window.navigator.standalone === true ||
      window.matchMedia('(display-mode: standalone)').matches
    );
  } catch {
    return false;
  }
}

export function isIosDevice() {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export function isAndroidDevice() {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

/** Learn guide path with device-specific hash when we can detect it. */
export function getInstallOnPhoneLearnPath() {
  if (isIosDevice()) return '/learn/software-guides#install-on-your-phone-ios';
  if (isAndroidDevice()) return '/learn/software-guides#install-on-your-phone-android';
  return '/learn/software-guides#install-on-your-phone';
}

export const INSTALL_APP_DISMISS_KEY = 'pt_install_app_prompt_dismissed';
